interface StockInputProps {
  productId: string;
  stock: number;
  type: 'deadline' | 'reservation';
  onChange: (productId: string, stock: number) => void;
  disabled?: boolean;
}

export function StockInput({
  productId,
  stock,
  type,
  onChange,
  disabled = false
}: StockInputProps) {
  // 예약할인은 기본적으로 무제한
  const isUnlimited = type === 'reservation' && stock === 999;

  const handleUnlimitedToggle = () => {
    onChange(productId, isUnlimited ? 10 : 999);
  };

  return (
    <div>
      <label className="block text-sm text-gray-600 mb-1">
        재고 수량
      </label>
      
      {type === 'reservation' ? (
        <div className="flex items-center gap-3">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={isUnlimited}
              onChange={handleUnlimitedToggle}
              disabled={disabled}
              className="mr-2"
            />
            <span className="text-sm text-gray-700">무제한</span>
          </label>
          
          {!isUnlimited && (
            <input
              type="number"
              value={stock}
              onChange={(e) => onChange(productId, Math.max(1, Number(e.target.value)))}
              disabled={disabled}
              className="flex-1 px-3 py-1.5 border border-gray-300 rounded-lg text-sm disabled:bg-gray-100 disabled:text-gray-500"
              min="1"
              max="999"
            />
          )}
        </div>
      ) : (
        <div>
          <input
            type="number"
            value={stock}
            onChange={(e) => onChange(productId, Math.max(1, Number(e.target.value)))}
            disabled={disabled}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm disabled:bg-gray-100 disabled:text-gray-500"
            min="1"
            max="100"
          />
          <p className="text-xs text-gray-500 mt-1">
            마감할인은 당일 판매 가능한 수량을 입력하세요
          </p>
        </div>
      )}
    </div>
  );
}